import { render, staticRenderFns } from "./CollaboratorTable.vue?vue&type=template&id=30ed37e6&"
import script from "./CollaboratorTable.vue?vue&type=script&lang=js&"
export * from "./CollaboratorTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports